import React, { Component } from 'react'
import { PropTypes } from 'prop-types'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'

import { badges as badgesApi } from 'redux/modules/api'
import { compose } from 'recompose'
import { get } from 'lodash'


function decorator(config = {}) {
  return ComposedComponent => {
    const enhance = compose(
    withRouter,
    connect(({ api }) => ({
      badges: api.badges,
      awards: get(api, 'dashboard.awards')
    }), { ...badgesApi }))
    class Badges extends Component {
      static propTypes = {
        badges: PropTypes.object.isRequired,
        awards: PropTypes.object.isRequired,
        getBadges: PropTypes.func.isRequired,
        getAwardBadges: PropTypes.func.isRequired,
        getBadgesProgress: PropTypes.func.isRequired,
        logError: PropTypes.func.isRequired,
        modal: PropTypes.func
      }

      static defaultProps = {
        params: {}
      }

      async componentDidMount() {
        const { match } = this.props

        const { params } = match

        const awardId = get(params, 'awardId')

        if (config.loadBadges) {
          const organizationId = get(this.props, 'awards.awards.data.organization.id')

          this.handleGetBadges(true, organizationId)
        }

        if (config.loadAwardBadges) {
          this.handleGetAwardBadges(awardId)
        }

        if (config.loadBadgesProgress) {
          this.handleGetBadgesProgress(awardId)
        }
      }

      handleGetBadges = (mergeGroups = false, cfgOrganizationId = 0) => {
          this.props.getBadges(mergeGroups, cfgOrganizationId)
      }

      handleGetAwardBadges = awardId => {
        this.props.getAwardBadges(awardId)
      }

      handleGetBadgesProgress = awardId => {
        this.props.getBadgesProgress(awardId)
      }

      render() {
        const params = {
          ...this.props,
          local: undefined
        }

        return (
          <ComposedComponent
            {...params}
            onGetBadges={this.handleGetBadges}
            onGetAwardBadges={this.handleGetAwardBadges}
            onGetBadgesProgress={this.handleGetBadgesProgress}
          />
        )
      }
    }
    return enhance(Badges)
  }
}

export default decorator

